import { Component } from '@theme/component';

/**
 * Reveals the story image and feature points once as they enter the viewport.
 *
 * @extends {Component<{ image: HTMLElement, points: HTMLElement[] }>}
 */
class StoryReveal extends Component {
  requiredRefs = ['image', 'points'];

  #observer;

  connectedCallback() {
    super.connectedCallback();

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;

          entry.target.setAttribute('data-revealed', '');
          this.#observer.unobserve(entry.target);
        }
      },
      {
        rootMargin: '-80px',
        threshold: 0.15,
      }
    );

    this.setAttribute('data-reveal-ready', '');
    this.#observer.observe(this.refs.image);

    for (const point of this.refs.points) {
      this.#observer.observe(point);
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#observer?.disconnect();
  }
}

if (!customElements.get('story-reveal')) {
  customElements.define('story-reveal', StoryReveal);
}
